interface SlideTwoProps {
  causeName: string;
  charityName: string;
  charityLogo: string;
  charityBackground: string;
}

export const SlideTwo = ({
  causeName,
  charityName,
  charityLogo,
  charityBackground
}: SlideTwoProps) => {
  const backgroundStyle = charityBackground
    ? { backgroundImage: `url(${charityBackground})` }
    : { backgroundColor: 'black' };
  return (
    <div class='slide slide-two' style={backgroundStyle}>
      <div class='overlay'></div>
      <div class='header'>
        <img
          src={`https://${import.meta.env.VITE_MEDIA_HOST}/white-heart.svg`}
          alt='featured cause'
        />{' '}
        Featured Cause
      </div>
      <div class='center-content'>
        <img src={charityLogo} alt={charityName} />
      </div>
      <div class='footer'>
        <div>{causeName}</div>
        <div>
          <i>w/</i> <strong>{charityName}</strong>
        </div>
      </div>
    </div>
  );
};
